<template>
  <div class="uk-container">
    <user-manage :type="2" :uid="$route.params.id" />
  </div>
</template>

<script>
import UserManage from '@/components/user/Manage.vue'

export default {
  name: 'ViewOperatorManage',

  components: { UserManage }
}
</script>
